import { apiHolder, getIn18Text, apis } from 'api';
import SiriusModal from '@web-common/components/UI/Modal/SiriusModal';
import { useGlobalEventObserver } from './useEventObserver';
import { config } from 'env_def';
const aiAssistant = apiHolder.api.requireLogicalApi(apis.aiAssistant);
const convertLang = (lang) => {
    switch (lang) {
        case 'en':
            return 'en_US';
        case 'zh':
            return 'zh_CN';
        case 'zh-trad':
            return 'zh_TW';
        default:
            return 'zh_CN';
    }
};
const handleRiskConfirm = (ev, eventApi) => {
    if (ev && ev.eventData) {
        const data = ev.eventData;
        const modal = SiriusModal.confirm({
            title: getIn18Text('FENGKONGLANJ'),
            content: getIn18Text('JIANCEDAOYXCZYDFXQJX12'),
            cancelText: getIn18Text('setting_system_switch_cancel'),
            okText: getIn18Text('SHENFENYANZ'),
            onOk: async () => {
                const webmailHost = config('webMailBJHost');
                const { operate, url } = data;
                const language = convertLang(window.systemLang);
                const fullPath = url.startsWith('/') ? url : '/' + url;
                const newUrl = `${webmailHost}${fullPath}&hl=${language}`;
                aiAssistant.openMiniApp({
                    url: newUrl,
                    windowSize: {
                        width: 1000,
                        height: 600,
                    },
                });
                eventApi.confirmEvent(ev);
                modal.destroy();
            },
            onCancel: () => {
                eventApi.confirmEvent(ev);
                modal.destroy();
            },
        });
    }
};
const useRiskConfirm = () => {
    const eventApi = apiHolder.api.getEventApi();
    useGlobalEventObserver('RiskHitInterrupt', (ev) => {
        handleRiskConfirm(ev, eventApi);
    });
};
export default useRiskConfirm;
